import { Container, Sprite, Text } from 'pixi.js';
import type { BoardModel } from '../../models/board/BoardModel';
import type { TileStackModel } from '../../models/board/TileStackModel';
import { gridPositionToPxPosition } from '../../utils/gridPositionToPxPosition';
import { TILE_COLOR_TEXTURE_MAP } from '../../TileColor';
import { TILE_Z_OFFSET } from './TileView';
import type { BlockerModel } from '../../types';
import { PlankBlockerModel } from '../../models/blockers/PlankBlockerModel';
import { ScoreBlockerModel } from '../../models/blockers/ScoreBlockerModel';
import { AdBlockerModel } from '../../models/blockers/AdBlockerModel';

export class DebugBoardView extends Container {
  constructor(private readonly model: BoardModel) {
    super();
    this.redraw();
  }

  public redraw(): void {
    this.children.slice().forEach((child) => {
      child.destroy({ children: true });
    });

    this.model.getStacks().forEach((model) => {
      this.createDebugView(model);
    });
    this.sortChildren();
  }

  private createDebugView(model: TileStackModel): Container {
    const view = new Container().props({
      position: gridPositionToPxPosition(model.x, model.y),
      zIndex: model.y * 1000 + (model.x % 2) * 100,
      parent: this,
    });

    new Sprite().props({
      texture: 'tile_empty',
      anchor: 0.5,
      parent: view,
    });

    model.getTiles().forEach((tile, index) => {
      new Sprite().props({
        texture: TILE_COLOR_TEXTURE_MAP[tile.color],
        anchor: 0.5,
        y: index * -TILE_Z_OFFSET,
        parent: view,
      });
    });

    if (model.blocker) {
      this.createBlockerView(model.blocker).props({
        parent: view,
        y: model.getTileCount() * -TILE_Z_OFFSET,
      });
    }

    return view;
  }

  private createBlockerView(blocker: BlockerModel): Container {
    const view = new Container();

    if (blocker instanceof PlankBlockerModel) {
      new Sprite().props({
        texture: 'Plank_1',
        anchor: 0.5,
        parent: view,
      });
      new Text(blocker.getHp(), {
        fill: 'white',
        fontSize: 30,
        stroke: { color: 'black', width: 4 },
      }).props({
        parent: view,
        anchor: 0.5,
      });
    } else if (blocker instanceof ScoreBlockerModel) {
      new Sprite().props({
        texture: 'Unlock_Frame_1',
        anchor: 0.5,
        parent: view,
      });
      new Text(blocker.getScore(), {
        fill: 'white',
        fontSize: 30,
        stroke: { color: 'black', width: 4 },
      }).props({
        parent: view,
        anchor: 0.5,
      });
    } else if (blocker instanceof AdBlockerModel) {
      new Sprite().props({
        texture: 'Unlock_Frame_1',
        anchor: 0.5,
        parent: view,
      });
      new Sprite().props({
        texture: 'Under_Lock_RV_Icon',
        anchor: 0.5,
        parent: view,
      });
    }

    return view;
  }
}
